import {CdkScrollableModule, ScrollingModule} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';

import {MatSidenavModule} from '@angular/material/sidenav';

import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {RouterModule} from '@angular/router';
import {AssetfilterModule} from '@app/assetfilter/assetfilter.module';

import {NgScrollbarModule} from 'ngx-scrollbar';

import {AssetModule} from '../asset/asset.module';
import {InspectorModule} from '../inspector/inspector.module';
import {StateModule} from '../state/state.module';
import {UploadModule} from '../upload/upload.module';
import {ViewerModule} from '../viewer/viewer.module';
import {MainComponent} from './main/main.component';

@NgModule({
    imports: [
        CommonModule,
        MatSidenavModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        NgScrollbarModule,
        CdkScrollableModule,
        ScrollingModule,
        AssetModule,
        InspectorModule,
        ViewerModule,
        UploadModule,
        StateModule,
        MatTooltipModule,
        RouterModule,
        AssetfilterModule,
        MatMenuModule,
        MainComponent,
    ],
})
export class MainModule {}
